
export const background = {
  name: 'background'
}

export const backgroundColor = {
  name: 'background-color'
}

export const backgroundImage = {
  name: 'background-image'
}

export const backgroundPosition = {
  name: 'background-position'
}

export const backgroundSize = {
  name: 'background-size'
}

export const backgroundOrigin = {
  name: 'background-origin'
}

export const backgroundRepeat = {
  name: 'background-repeat'
}

export const backgroundClip = {
  name: 'background-clip'
}

export const backgroundBlendMode = {
  name: 'background-blend-mode'
}